import { $$ } from 'utils/dom';
import Shower from 'modules/shower';

const accordionWrappers = $$('.o-accordion');
if (accordionWrappers.length) {
  accordionWrappers.forEach(accordionWrapper => {
    const handlers = $$('.o-accordion__head', accordionWrapper);

    const togglers = handlers.map((handler, i) => {
      const target = handler.nextElementSibling;
      return new Shower({
        target,
        handler,
        easing: 'ease',
        duration: 400,
        initOpened: false,
        openClassName: 'is-open',
      });
    });

    togglers.forEach(toggle => {
      // send in the other Show instances to close when one opens
      toggle.closeInstances = togglers.filter(t => t !== toggle);
      toggle.init();
    });
  });
}
